import { render, staticRenderFns } from "./TableInspect.vue?vue&type=template&id=0b48652e&scoped=true&"
import script from "./TableInspect.vue?vue&type=script&lang=js&"
export * from "./TableInspect.vue?vue&type=script&lang=js&"
import style0 from "./TableInspect.vue?vue&type=style&index=0&id=0b48652e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b48652e",
  null
  
)

export default component.exports